export const getDefaultCountry = (country?: string | null): 'de' | 'at' => (country as 'de' | 'at') || 'de'
